import React from "react";
import ResourcePage from "@/components/ResourcePage";
import { COUNTRIES } from "@/lib/api";

const STATUSES = ["NEW", "UNDER REVIEW", "QUOTED", "NEGOTIATION", "WON", "LOST"];

export default function RFQs() {
  return (
    <ResourcePage
      title="RFQs" name="RFQ" endpoint="rfqs"
      subtitle="Requests for quotation from international buyers"
      emptyMessage="No RFQs yet. Once an international buyer requests a quotation, it will appear here."
      canExport relations={["buyers", "products", "users"]}
      statusOptions={STATUSES}
      convert={{ endpoint: (id) => `rfqs/${id}/convert-to-quotation`, to: "/quotations", label: "To Quote", toast: "Quotation created", resultKey: "quotation_number" }}
      columns={[
        { key: "rfq_number", label: "RFQ No.", type: "mono" },
        { key: "buyer_name", label: "Buyer" },
        { key: "country", label: "Country" },
        { key: "product_name", label: "Product" },
        { key: "quantity", label: "Qty" },
        { key: "estimated_value", label: "Est. Value", type: "currency" },
        { key: "status", label: "Status", type: "status" },
      ]}
      defaultValues={{ status: "NEW", unit: "units", estimated_value: 0 }}
      formFields={[
        { name: "buyer_id", label: "Buyer", type: "relation", source: "buyers", required: true },
        { name: "product_id", label: "Product", type: "relation", source: "products" },
        { name: "country", label: "Buyer country", type: "select", options: COUNTRIES },
        { name: "quantity", label: "Quantity" },
        { name: "unit", label: "Unit" },
        { name: "packaging", label: "Required packaging" },
        { name: "destination_country", label: "Destination country", type: "select", options: COUNTRIES },
        { name: "destination_port", label: "Destination port" },
        { name: "delivery_date", label: "Required delivery date", type: "date" },
        { name: "assigned_to", label: "Assigned to", type: "relation", source: "users" },
        { name: "estimated_value", label: "Estimated value (₹)", type: "number" },
        { name: "status", label: "Status", type: "select", options: STATUSES },
        { name: "requirements", label: "Buyer requirements", type: "textarea", full: true },
      ]}
    />
  );
}
